import {SxType} from "@baseTypes/sx/sxTypes";

export const sx:SxType = {
    root:{
        width:'100%',
        padding:'30px 0',
        '& .pointsReorderMutateSingleVoyage':{
            display:'flex',
            flexWrap:'wrap',
            width:'100%',
        }
    },
    card: {
        width:'200px',
        borderRadius: '4px',
        boxShadow: 'none',
        padding: '10px 13px',
        position: 'relative',
        display: 'flex',
        gap: '6px',
        flexDirection: 'column',
        border: '1px solid transparent',
        transition: 'all .3s',
        height:'70px',
        '.lightTheme &': {
            backgroundColor: '#fff',
        },
    },
    cardWrapper:{
        padding:'5px'
    },
    name:{
        fontSize:'10px'
    },
    circle:{
        fontSize:'10px!important',
        width: '25px',
        height: '25px',
    },
    divider:{
        margin:'10px 0',
    }
}